import React from "react";
import ProcessFlowImage from "../agentic/ProcessFlowImage";
import ManufacturingProcessFlow from "../agentic/ManufacturingProcessFlow";
import HRProcessFlow from "../agentic/HRProcessFlow";
import BFSIProcessFlow from "../agentic/BFSIProcessFlow";
import HealthcareProcessFlow from "../agentic/HealthcareProcessFlow";
import LogisticsProcessFlow from "../agentic/LogisticsProcessFlow";
import RetailProcessFlow from "../agentic/RetailProcessFlow";
import InsuranceProcessFlow from "../agentic/InsuranceProcessFlow";
import TelecomProcessFlow from "../agentic/TelecomProcessFlow";
import PublicSectorProcessFlow from "../agentic/PublicSectorProcessFlow";
import RealEstateProcessFlow from "../agentic/RealEstateProcessFlow";
import HospitalityProcessFlow from "../agentic/HospitalityProcessFlow";
import AgricultureProcessFlow from "../agentic/AgricultureProcessFlow";
import ITServicesProcessFlow from "../agentic/ITServicesProcessFlow";
import AviationProcessFlow from "../agentic/AviationProcessFlow";
import AutomotiveProcessFlow from "../agentic/AutomotiveProcessFlow";
import PharmaProcessFlow from "../agentic/PharmaProcessFlow";
import MediaProcessFlow from "../agentic/MediaProcessFlow";
import EnergyProcessFlow from "../agentic/EnergyProcessFlow";
import EducationProcessFlow from "../agentic/EducationProcessFlow";
import RpaProcessFlow from "../rpa/RpaProcessFlow";

const AGENTIC_FLOWS = {
  "financial-domain": (uc) =>
    uc.image ? <ProcessFlowImage src={uc.image} alt={uc.imageAlt || uc.title} /> : null,
  manufacturing: (uc) => <ManufacturingProcessFlow subIndustry={uc.subIndustry} />,
  "hr-domain": (uc) => <HRProcessFlow useCaseId={uc.id} />,
  "bfsi-domain": (uc) => <BFSIProcessFlow useCaseId={uc.id} />,
  "healthcare-domain": (uc) => <HealthcareProcessFlow useCaseId={uc.id} />,
  "logistics-domain": (uc) => <LogisticsProcessFlow useCaseId={uc.id} />,
  "retail-domain": (uc) => <RetailProcessFlow useCaseId={uc.id} />,
  "insurance-domain": (uc) => <InsuranceProcessFlow useCaseId={uc.id} />,
  "telecom-domain": (uc) => <TelecomProcessFlow useCaseId={uc.id} />,
  "public-sector-domain": (uc) => <PublicSectorProcessFlow useCaseId={uc.id} />,
  "real-estate-domain": (uc) => <RealEstateProcessFlow useCaseId={uc.id} />,
  "hospitality-domain": (uc) => <HospitalityProcessFlow useCaseId={uc.id} />,
  "agriculture-domain": (uc) => <AgricultureProcessFlow useCaseId={uc.id} />,
  "it-services-domain": (uc) => <ITServicesProcessFlow useCaseId={uc.id} />,
  "aviation-domain": (uc) => <AviationProcessFlow useCaseId={uc.id} />,
  "automotive-domain": (uc) => <AutomotiveProcessFlow useCaseId={uc.id} />,
  "pharma-domain": (uc) => <PharmaProcessFlow useCaseId={uc.id} />,
  "media-domain": (uc) => <MediaProcessFlow useCaseId={uc.id} />,
  "energy-domain": (uc) => <EnergyProcessFlow useCaseId={uc.id} />,
  "education-domain": (uc) => <EducationProcessFlow useCaseId={uc.id} />,
};

export function renderUseCaseFlow(mode, domainSlug, useCase) {
  if (mode === "rpa") {
    return <RpaProcessFlow useCase={useCase} />;
  }
  const render = AGENTIC_FLOWS[domainSlug];
  return render ? render(useCase) : null;
}

